$(document).ready(function () {
  // Shipping Delivery calculation
  var calculator = {
    workDaysAdded: 0,
    month: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    weekday: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    ukHolidays: [], //"2023-05-23", "2023-05-24"
    startDate: null,
    curDate: null,

    addWorkDay: function () {
      this.curDate.setDate(this.curDate.getDate() + 1);
      if (
        this.ukHolidays.indexOf(this.formatDate(this.curDate)) === -1 &&
        this.curDate.getDay() !== 0 &&
        this.curDate.getDay() !== 6
      ) {
        this.workDaysAdded++;
      }
    },

    formatDate: function (date) {
      var day = date.getDate(),
        month = date.getMonth() + 1;

      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;
      return date.getFullYear() + "-" + month + "-" + day;
    },

    getNewWorkDay: function (daysToAdd) {
      this.startDate = new Date();
      this.curDate = new Date();
      this.workDaysAdded = 0;

      while (this.workDaysAdded < daysToAdd) {
        this.addWorkDay();
      }
      return [
        this.weekday[this.curDate.getDay()],
        this.month[this.curDate.getMonth()],
        this.curDate.getDate(),
      ];
    },
  };

  // function shipping_work_day(day) {
  //   var newWorkDay = calculator.getNewWorkDay(day);
  //   $j(".product-form_ship-in-ring-timeline b").text(
  //     `${newWorkDay[0]}, ${newWorkDay[1]} ${newWorkDay[2]}`
  //   );
  //   $j(".product-form__item--submit #properties-ship-by").val(
  //     `${newWorkDay[0]}, ${newWorkDay[1]} ${newWorkDay[2]}`
  //   );
  //   $j(".product-form__item--submit #properties-ship-in").val(`${day}`);
  // }

  // Ajax drawer js start
  var ajaxCartDrawer = {
    AjaxcartUpdateCartCount: function (cart) {
      var CartCount = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("count");
      $("[data-cart-count]").html(CartCount);
      var price_without_money = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("cart-total-price");
      var price_with_money = $("#withclarity-ajax-cart")
        .find(".cart__products")
        .data("cart-total-money");
      $("#product-content").html(price_without_money);
      $(".cart-subtotal__price").html(price_with_money);
    },
    AjaxcartFreeRemove: function (variant1, variant2, itemVariants) {
      console.log(itemVariants);
      function removeProductAjax(variant) {
        const product = {
          quantity: 0,
        };
        product["id"] = variant;
        console.log(product);
        $.ajax({
          url: "/cart/change.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: product,
          async: true,
          success: function (change_cart) {
            $.get("/cart?view=ajax", function (cart) {
              $("#withclarity-ajax-cart").html(cart);
              //   Update cart icon count
              var CartCount = change_cart.item_count;
              console.log(CartCount);
              ajaxCartDrawer.AjaxcartUpdateCartCount();
              if (!CartCount) {
                ajaxCartDrawer.AjaxcartNoProduct();
              }
            });
            $("body").removeClass("show-cart-loader");
          },
          error: function (error) {
            console.log(error);
          },
        });
      }

      console.log(itemVariants);
      if (
        itemVariants.indexOf(variant1) > -1 ||
        itemVariants.indexOf(variant2) > -1 ||
        itemVariants.indexOf(47906827763995) > -1 ||
        itemVariants.indexOf(47380835041563) > -1
      ) {
        console.log("rahul");
        if (itemVariants.indexOf(variant1) > -1) {
          removeProductAjax(variant1);
        }
        if (itemVariants.indexOf(variant2) > -1) {
          removeProductAjax(variant2);
        }
        if (itemVariants.indexOf(47906827763995) > -1) {
          removeProductAjax(47906827763995);
        }
        if (itemVariants.indexOf(47380835041563) > -1) {
          removeProductAjax(47380835041563);
        }
      } else {
        $("body").removeClass("show-cart-loader");
      }
    },
    AjaxcartFreeAdd: function (variant1, variant2, itemVariants) {
      try {
        if (itemVariants.indexOf(variant1) < 0) {
          var product1 = {
            quantity: 1,
          };
          product1["id"] = variant1;
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: product1,
            dataType: "json",
            async: false,
            success: function (data) {
              console.log(data);
              $.ajax({
                url: "/cart?view=ajax",
                type: "get",
                async: false,
                success: function (cart) {
                  $("#withclarity-ajax-cart").html(cart);
                },
                error: function (e) {},
              });
            },
          });
        }
        if (itemVariants.indexOf(variant2) > -1) {
          var product2 = {
            quantity: 0,
          };
          product2["id"] = variant2;
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: product2,
            dataType: "json",
            async: false,
            success: function (data) {
              console.log(data);
              $.ajax({
                url: "/cart?view=ajax",
                type: "get",
                async: false,
                success: function (cart) {
                  $("#withclarity-ajax-cart").html(cart);
                },
                error: function (e) {},
              });
            },
          });
        }
        /** Code is written to not add any free product if previous free product in cart */
        if (itemVariants.indexOf(48302200389915) > -1) {
          var product2 = {
            quantity: 0,
          };
          product2["id"] = 48302200389915;
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: product2,
            dataType: "json",
            async: false,
            success: function (data) {
              console.log(data);
              $.ajax({
                url: "/cart?view=ajax",
                type: "get",
                async: false,
                success: function (cart) {
                  $("#withclarity-ajax-cart").html(cart);
                },
                error: function (e) {},
              });
            },
          });
        }
        if (itemVariants.indexOf(48302200422683) > -1) {
          var product2 = {
            quantity: 0,
          };
          product2["id"] = 48302200422683;
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: product2,
            dataType: "json",
            async: false,
            success: function (data) {
              console.log(data);
              $.ajax({
                url: "/cart?view=ajax",
                type: "get",
                async: false,
                success: function (cart) {
                  $("#withclarity-ajax-cart").html(cart);
                },
                error: function (e) {},
              });
            },
          });
        }
        /** Code is written to not add any free product if previous free product in cart */
        setTimeout(function () {
          ajaxCartDrawer.AjaxcartUpdateCartCount();
          $("body").removeClass("show-cart-loader");
        }, 500);
      } catch (e) {
        console.log(e);
      }
    },
    AjaxcartFreeProduct: function (isLoading) {
      // Has free product check
      // if (
      //   itemVariants.indexOf(freeProductTier[0]) > -1 ||
      //   itemVariants.indexOf(freeProductTier[1]) > -1 ||
      //   itemVariants.indexOf(freeProductTier[2]) > -1
      // ) {
      //   hasFreeProduct = true;
      // }
      var cartTotal = parseInt(
        $("#withclarity-ajax-cart")
          .find(".cart__products")
          .data("cart-price-except-home-preview")
      );
      var currency_conversion_rate = 1;
      switch (theme.country_iso_code) {
        case "GB":
          currency_conversion_rate = 0.81;
          break;
        case "CA":
          currency_conversion_rate = 1.37;
          break;
        case "AU":
          currency_conversion_rate = 1.54;
          break;
        default:
      }
      var priceTier = [
        100000 * currency_conversion_rate,
        300000 * currency_conversion_rate,
      ];
      console.log(cartTotal, priceTier);
      var freeProductTier = [48649161081115, 48657245896987];
      var itemVariants = [];
      $(".cart__products .cart__row").each(function () {
        var itemVariant = $(this).data("variant-id");
        if (itemVariant) {
          itemVariants.push(itemVariant);
        }
      });
      if (cartTotal > 99999) {
        if (
          cartTotal >= parseInt(priceTier[0]) &&
          cartTotal < parseInt(priceTier[1])
        ) {
          ajaxCartDrawer.AjaxcartFreeAdd(
            freeProductTier[0],
            freeProductTier[1],
            itemVariants
          );
        } else if (cartTotal >= parseInt(priceTier[1])) {
          ajaxCartDrawer.AjaxcartFreeAdd(
            freeProductTier[1],
            freeProductTier[0],
            itemVariants
          );
        }
      } else if (cartTotal < 100000) {
        ajaxCartDrawer.AjaxcartFreeRemove(
          freeProductTier[0],
          freeProductTier[1],
          itemVariants
        );
      }
    },
    AjaxcartNoProduct: function (elements) {
      $("[data-cart-wrapper],#shopify-section-cart-faqs").addClass("hide");
      $("[data-empty-page-content]").removeClass("hide");
      $("body").removeClass("show-cart-loader");
    },
    AjaxcartRender: function () {
      $("body").addClass("show-cart-loader");
      $.ajax({
        url: "/cart?view=ajax",
        type: "get",
        async: false,
        success: function (cart) {
          $("#withclarity-ajax-cart").html(cart);
          ajaxCartDrawer.AjaxcartUpdateCartCount();
          $("body").removeClass("show-cart-loader");
          ajaxCartDrawer.AjaxcartFreeProduct();
          $("#withclarity-ajax-cart [data-cart-item-type]").each(function () {
            const custom_delivery_date_selector = $(this).find(
              ".custom-delivery-date_property"
            );
            const day = custom_delivery_date_selector.attr("data-ships-in");
            // console.log(days);
            var newWorkDay = calculator.getNewWorkDay(day);
            custom_delivery_date_selector
              .find("[data-cart-item-property-value]")
              .text(`${newWorkDay[0]}, ${newWorkDay[1]} ${newWorkDay[2]}`);
          });
        },
        error: function (e) {
          $("body").removeClass("show-cart-loader");
          ajaxCartDrawer.AjaxcartUpdateCartCount();
          alert(e.responseJSON.message);
        },
      });
    },
    AjaxcartChangeHandler: function (data) {
      $("body").addClass("show-cart-loader");
      $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: data,
        async: true,
        success: function (cart) {
          console.log(cart);
          ajaxCartDrawer.AjaxcartRender();
          var CartCount = cart.item_count;
          $("[data-cart-count]").html(CartCount);
          $(".cart-popup__heading span").text(CartCount);
          if (!CartCount) {
            ajaxCartDrawer.AjaxcartNoProduct();
          }
          // window.location.href = "/cart";
        },
        error: function (e) {
          $("body").removeClass("show-cart-loader");
          // ajaxCartDrawer.AjaxcartUpdateCartCount();
          alert(e.responseJSON.message);
          window.location.href = "/cart";
        },
      });
    },
    AjaxcartQuantityHandler: function () {
      $(document).on("click", ".qty_plus", function () {
        var product_title = $(this)
          .closest(".cart__row")
          .data("cart-item-title");
        var max_quantity = parseInt(
          $(".cart__products").data("appraisal-limit")
        );
        var q = $(this).parent().find(".cart__qty-input").val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;
        if (
          product_title.indexOf("Appraisal Report") > -1 &&
          u > max_quantity
        ) {
          alert(
            `One appraisal report per product. Exception: Loose diamonds have no appraisal reports. Contact support for assistance. `
          );
          return false;
        }
        var line = $(this)
            .closest(".cart__qty")
            .find("input")
            .attr("data-line"),
          params = {
            quantity: u,
            line: line,
          };
        $(this).parent().find(".cart__qty-input").val(u);
        ajaxCartDrawer.AjaxcartChangeHandler(params);
      });
      $(document).on("click", ".qty_minus", function () {
        var q = $(this).parent().find(".cart__qty-input").val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
        if (i == q) {
          return false;
        }
        var line = $(this)
            .closest(".cart__qty")
            .find("input")
            .attr("data-line"),
          params = {
            quantity: u,
            line: line,
          };
        $(this).parent().find(".cart__qty-input").val(u);
        ajaxCartDrawer.AjaxcartChangeHandler(params);
      });
      $(document).on("change", ".cart__qty-input", function () {
        var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr("data-line")),
          params = {
            quantity: UpdatedQuantity,
            line: QuantityLine,
          };
        ajaxCartDrawer.AjaxcartChangeHandler(params);
      });
      $(document).on("click", ".cart-remove-btn", function (e) {
        e.preventDefault();
        var RemoveLine = parseInt($(this).attr("data-line")),
          params = {
            quantity: 0,
            line: RemoveLine,
          };
        ajaxCartDrawer.AjaxcartChangeHandler(params);
      });
    },
    AjaxcartAddAppraisal: function () {
      $(document).on("click", ".cart__add-appraisal .btn", function (e) {
        e.preventDefault();
        var max_limit = $(".cart__products").data("appraisal-limit");
        var appraisalProduct = {
          id: 45178235617563,
          quantity: 1,
          properties: {
            Note: "Including an appraisal report will extend shipping by 2 days.",
          },
        };
        $("body").addClass("show-cart-loader");
        $("html, body").animate({ scrollTop: "0" });
        try {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: appraisalProduct,
            dataType: "json",
            async: true,
            success: function () {
              // window.location.href = "/cart";
              ajaxCartDrawer.AjaxcartRender();
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              console.log(XMLHttpRequest, textStatus, errorThrown);
            },
          });
        } catch (e) {
          console.loe(e);
        }
      });
      $(document).on(
        "click",
        ".free-gift-wrapper .primary-button",
        function (e) {
          e.preventDefault();
          var varaintId = $(this).data("variant-id");
          var appraisalProduct = {
            quantity: 1,
          };
          appraisalProduct["id"] = varaintId;
          $("body").addClass("show-cart-loader");
          try {
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: appraisalProduct,
              dataType: "json",
              async: true,
              success: function () {
                // code to apply discount code to checkout
                if (varaintId == "45519923708187") {
                  $("#checkout-discount").val("FREESTUDS1000");
                } else if (varaintId == "45519923904795") {
                  $("#checkout-discount").val("FREESTUDS5000");
                } else if (varaintId == "45519924003099") {
                  $("#checkout-discount").val("FREESTUDS10000");
                }
                ajaxCartDrawer.AjaxcartRender();
              },
              error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.log(XMLHttpRequest, textStatus, errorThrown);
              },
            });
          } catch (e) {
            console.loe(e);
          }
        }
      );
      // appraisal popup button
      $(document).on(
        "click",
        ".cart__add-appraisal .appraisal-title",
        function () {
          $("body").addClass("show-website-popup");
          $("#cart-appraisal-popup").addClass("show-popup-content");
        }
      );
      // clear diamond availability cookies
      $(".cart__submit-controls [type='submit']").on("click", function () {
        sessionStorage.removeItem("unavailable_diamond");
        sessionStorage.removeItem("diamond-checklist");
      });
    },
  };
  $("body").addClass("show-cart-loader");
  ajaxCartDrawer.AjaxcartRender();
  ajaxCartDrawer.AjaxcartQuantityHandler();
  ajaxCartDrawer.AjaxcartAddAppraisal();
});
